import React from "react";
import * as Styled from "./styles";
import { ASSETS } from "../../../../utils/config";
import { useDispatch, useSelector } from "react-redux";
import { getSelectedMenu } from "../../../../redux/selectors/segmentBuilderSelectors";
import {
  handleCloseMenu,
  handleMenuChange,
} from "../../../../redux/reducers/segmentBuilder";
import useSegmentBuilder from "../../../../hooks/useSegmentBuilder";
import { useEditor } from "@craftjs/core";

const menuItems = [
  {
    id: 1,
    icon: ASSETS.segmentEditor.Setting,
    text: "Wheel",
    menuInnerProps: {},
    iconWrapperProps: {},
    textWrapperProps: { padding: "0px 0px 0px 5px" },
  },
  {
    id: 2,
    icon: ASSETS.segmentEditor.Segment,
    text: "Segment",
    menuInnerProps: { width: "51px", height: "60px" },
    iconWrapperProps: {
      width: "40px",
      height: "40px",
      margin: "0px 0px 0px 6px",
    },
    textWrapperProps: {},
  },
  {
    id: 3,
    icon: ASSETS.segmentEditor.Edit,
    text: "Build",
    menuInnerProps: { width: "40px", height: "60px" },
    iconWrapperProps: { width: "40px", height: "40px" },
    textWrapperProps: { padding: "0px 0px 0px 5px" },
  },
  {
    id: 4,
    icon: ASSETS.segmentEditor.Hotbar,
    text: "Hotbar",
    menuInnerProps: { width: "40px", height: "60px" },
    iconWrapperProps: { width: "40px", height: "40px" },
    textWrapperProps: { padding: "0px 0px 0px 5px" },
  },
  {
    id: 5,
    icon: ASSETS.segmentEditor.Business,
    text: "Business",
    menuInnerProps: { width: "40px", height: "60px" },
    iconWrapperProps: { width: "40px", height: "40px" },
    textWrapperProps: {},
  },
  {
    id: 6,
    icon: ASSETS.segmentEditor.SegmentLibrary,
    text: "Segment Library",
    menuInnerProps: { width: "40px", height: "60px" },
    iconWrapperProps: { width: "40px", height: "40px" },
    textWrapperProps: { padding: "0px 0px 0px 5px" },
  },
];

const MenuItem = ({
  id,
  icon,
  text,
  selected,
  handleMenuChange,
  menuInnerProps,
  iconWrapperProps,
  textWrapperProps,
}) => (
  <Styled.MenuContainer
    onClick={() => handleMenuChange(id)}
    backgroundColor={selected === id ? "white" : "#f9f5ff"}
  >
    <Styled.MenuIconWrapper {...iconWrapperProps}>
      <img src={icon} width={38} height={38} alt={`${text} Icon`} />
    </Styled.MenuIconWrapper>
    <Styled.MenuTextWrapper>
      <Styled.MenuText {...textWrapperProps}>{text}</Styled.MenuText>
    </Styled.MenuTextWrapper>
  </Styled.MenuContainer>
);

const SideMenu = () => {
  const selectedMenu = useSelector(getSelectedMenu);
  const { isToolSelected } = useSegmentBuilder();
  const { actions } = useEditor();
  const { selected } = isToolSelected() || {};
  const dispatch = useDispatch();

  const handleChange = (id) => {
    if (selectedMenu == 3 && selected && id == 3) {
      actions.selectNode(null);
      return;
    }
    if (selectedMenu == id) dispatch(handleCloseMenu());
    else dispatch(handleMenuChange({ num: id }));
  };

  return (
    <Styled.SideMenuMainDiv>
      {menuItems.map((item) => (
        <MenuItem
          key={item.id}
          id={item.id}
          icon={item.icon}
          text={item.text}
          selected={selectedMenu}
          handleMenuChange={handleChange}
          menuInnerProps={item.menuInnerProps}
          iconWrapperProps={item.iconWrapperProps}
          textWrapperProps={item.textWrapperProps}
        />
      ))}
    </Styled.SideMenuMainDiv>
  );
};

export default SideMenu;
